module.exports = __webpack_public_path__ + "img/cdbaby.03a8cfab.png";